import { useContext } from 'react';
import StudentContext, { StudentContextProps } from '@/data/context/_deprecated/StudentContext';

/**
 * @deprecated Legacy student god-context kept only for the old UI during the
 * new UI migration. For the new student dashboard, use `useStudentDashboard`
 * from `@/data/context/StudentDashboardContext` instead.
 */
const useStudentContext = (): StudentContextProps => useContext(StudentContext);

export default useStudentContext;
